module.exports = __webpack_public_path__ + "img/prize-01.7429e964.png";